import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
/** @typedef {import('vue').Ref<import('../types/assessment').AssessmentTypes>} Assessment */

export const useAssessmentStore = defineStore('assessment', () => {
  /** @type {Assessment} */
  const assessment = ref({})
  const loading = ref({ assessment: true })
  const assessments = ref({
    data: [],
    next: null,
    loading: { req: true, more: false },
  })

  const botoesHeader = computed(
    () => assessment.value?.botaoheader_set || []
  )

  return {
    assessment,
    loading,
    botoesHeader,
    assessments,
  }
})
